<template>
    <div class="table-responsive">
        <!-- <h5>Relationships</h5> -->
        <loader v-if="isLoading" />
        <b-table-simple v-else borderless hover class="list">
            <b-thead>
                <b-tr>
                    <b-th>Name:</b-th>
                    <b-th>Type:</b-th>
                    <b-th>Breed:</b-th>
                    <b-th>Sex:</b-th>
                    <b-th>Color:</b-th>
                    <b-th>Age:</b-th>
                    <b-th>Assigned:</b-th>
                    <b-th></b-th>
                </b-tr>
            </b-thead>
            <b-tbody>
                <b-tr
                    v-for="relationship in relationships"
                    :key="relationship.id"
                >
                    <b-td>
                        <client-name
                            v-if="relationship.entity_type == 'tbl_actor'"
                            :client="{
                                encoded_id: relationship.encoded_id,
                                status: relationship.status_id
                            }"
                            :text="relationship.name"
                        />
                        <patient-name
                            v-else
                            :use-router="USE_PATIENT_MODULE_VUE"
                            :patient="relationship"
                            :status="relationship.status_id"
                        />
                        <input
                            type="hidden"
                            name="id"
                            :value="relationship.id"
                        />
                    </b-td>
                    <b-td class="text-capitalize">
                        {{ relationship.relation_type }}
                    </b-td>
                    <b-td> {{ getEntityBreed(relationship) }} </b-td>
                    <b-td> {{ relationship.sex }} </b-td>
                    <b-td> {{ relationship.color }} </b-td>
                    <b-td> {{ relationship.age }} </b-td>
                    <b-td>
                        {{ _setDateDisplay(relationship.assigned_date) }}</b-td
                    >
                    <b-td class="text-right">
                        <b-dropdown
                            variant="link"
                            toggle-class="text-decoration-none"
                            no-caret
                            right
                            v-if="canRemove"
                        >
                            <template v-slot:button-content>
                                <i class="cus-cog-down"></i>
                            </template>
                            <b-dropdown-item
                                href="#"
                                @click="confirmDelete(relationship)"
                            >
                                <i class="cus-delete"></i>
                                Delete Relationship
                            </b-dropdown-item>
                        </b-dropdown>
                    </b-td>
                </b-tr>
                <b-tr v-if="relationships.length === 0">
                    <b-td colspan="8">
                        <i>No records available</i>
                    </b-td>
                </b-tr>
            </b-tbody>
        </b-table-simple>

        <b-pagination
            v-if="meta"
            v-show="meta.lastPage > 1"
            class="vet-pagination"
            align="right"
            v-model="meta.currentPage"
            :total-rows="meta.total"
            :per-page="meta.perPage"
            prev-text="Prev"
            next-text="Next"
            :hide-goto-end-buttons="true"
            @change="getList"
        />
        <modal-delete
            modal-id="confirm-delete-modal"
            ref="modalDelete"
            :relation="selectedRelation"
            :client-id="clientId"
            @reload="getList()"
        />
    </div>
</template>
<script>
import Client from "@/services/client";
import Loader from "@/components/elements/loader-list";
import ModalDelete from "@/components/client-relationships/relationship-delete-modal";
import PatientName from "@/components/commons/patient-name";
import ClientName from "@/components/commons/client-name";

export default {
    components: {
        Loader,
        ModalDelete,
        PatientName,
        ClientName
    },
    data() {
        return {
            relationships: [],
            isLoading: false,
            canRemove: false,
            selectedRelation: null,
            meta: null
        };
    },
    computed: {
        clientId() {
            return this.$store.state.client.client_id;
        }
    },
    mounted() {
        this.getList();
    },
    methods: {
        getList(page) {
            this.isLoading = true;

            Client.getRelationships(this.clientId, {
                page: page ? page : 1
            })
                .then(response => {
                    if (response.message.code == 200) {
                        this.canRemove = response.permissions
                            ? response.permissions.client_patient_remove
                            : false;
                        this.relationships = response.resource;
                        this.meta = response.meta;
                        this.isLoading = false;
                    } else {
                        this.showError();
                    }
                })
                .catch(error => {
                    this.showError();
                    console.error(error);
                });
        },
        showError() {
            this._message("Error : Unable to get relationship list", "danger");
            this.isLoading = false;
        },
        getEntityBreed(relation) {
            var entityBreed = "";
            // --- loop each breeds
            if (
                relation.patient_breeds &&
                _.keys(relation.patient_breeds).length > 0
            ) {
                var breeds = [];
                $.each(relation.patient_breeds, function (i, v) {
                    breeds.push(v.name);
                });
                // --- append breeds to species
                if (relation.species && _.keys(relation.species).length > 0) {
                    entityBreed =
                        breeds.join(", ") + " (" + relation.species + ")";
                }
            }

            return entityBreed;
        },
        confirmDelete(relation) {
            this.selectedRelation = relation;
            this.$refs.modalDelete.open();
        }
    }
};
</script>
